import type { Stock } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StocksService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getStocks = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, Stock[]>({
      method: 'GET',
      url: '/api/app/stocks/stocks',
    },
    { apiName: this.apiName,...config });
}